import {AfterContentInit, Directive, ElementRef, HostListener, Optional} from '@angular/core';
import {NgControl, Validators} from '@angular/forms';

@Directive({
  selector: '[ptgInputZipCode]'
})
export class InputZipCodeDirective implements AfterContentInit {

  pattern = /^[0-9\-]*$/;
  patternNumberAndHyphenOnly = /^(?=[\d-]{10}$)\d{5}-\d+$/;
  patternNumber = /^(\d{5}|\d{9})?$/;
  patternNumberNine = /^(\d{9})?$/;
  nativeElement;
  constructor( private element: ElementRef, @Optional() private control: NgControl) {
    this.nativeElement = element.nativeElement;
  }
  ngAfterContentInit() {
    this.onFocusOut();
  }
  @HostListener('keypress', ['$event']) onkeyValid(event: any): boolean {
    const keyId = this.onKeyID(event.key);
    if (keyId) {
      return false;
    }
    return true;
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    if (event.clipboardData) {
      const pasteInp = event.clipboardData.getData('text/plain').split('');
      const pasteVal = pasteInp?.filter((item: any) => {
        if (!this.onKeyID(item)) {
          return item;
        }
      });
      let value = pasteVal.join('');
      if (this.patternNumberNine.test(value)) {
        const match = value.match(/^(\d{5})(\d{4})$/);
        value = match ? `${match[1]}-${match[2]}` : value;
      }
      document.execCommand('insertText', false, value);
      event.preventDefault();
    } else if (event.clipboardData) {
      event.preventDefault();
    }
  }

  /** Show error for form control */
  @HostListener('focusout') onFocusOut() {
    const value = this.nativeElement.value;
    if (this.control && value.length) {
      const timeOut = setTimeout(()=> {
        if (value.length === 10 && !this.patternNumberAndHyphenOnly.test(value) || value.length < 10 && !this.patternNumber.test(value)) {
          this.control.control?.setErrors({ pattern: true });
        } else {
          if (this.patternNumberNine.test(value)) {
            const match = value.match(/^(\d{5})(\d{4})$/);
            this.control.control?.setValue( match ?`${match[1]}-${match[2]}`: value);
          }
          this.control.control?.setErrors(null);
        }
        this.control.control?.markAsTouched();
        clearTimeout(timeOut);
      }, 100);
    }

  }


  onKeyID(event: any): any {
    const valueId = event;
    if (!this.pattern.test(valueId)) {
      return true;
    }
  }

}
